const ENGLISH_TO_PERSIAN_KEYBOARD: Record<string, string> = {
  q: "ض",
  w: "ص",
  e: "ث",
  r: "ق",
  t: "ف",
  y: "غ",
  u: "ع",
  i: "ه",
  o: "خ",
  p: "ح",
  "[": "ج",
  "]": "چ",
  "\\": "پ",
  a: "ش",
  s: "س",
  d: "ی",
  f: "ب",
  g: "ل",
  h: "ا",
  H: "آ",
  j: "ت",
  k: "ن",
  l: "م",
  ";": "ک",
  "'": "گ",
  z: "ظ",
  x: "ط",
  c: "ز",
  C: "ژ",
  v: "ر",
  b: "ذ",
  n: "د",
  m: "ئ",
  ",": "و",
  "`": "ذ",
};

const CASE_SENSITIVE_ENGLISH_KEYS = new Set(["H", "C"]);

export const normalizePersianDigits = (input: string): string =>
  input.replace(/[۰-۹٠-٩]/g, (digit) => {
    const persianIndex = "۰۱۲۳۴۵۶۷۸۹".indexOf(digit);
    if (persianIndex !== -1) return persianIndex.toString();
    return "٠١٢٣٤٥٦٧٨٩".indexOf(digit).toString();
  });

export const englishKeyboardToPersian = (input: string): string =>
  input.replace(/[a-zA-Z\[\]\\;',.`]/g, (char) => {
    if (CASE_SENSITIVE_ENGLISH_KEYS.has(char)) {
      return ENGLISH_TO_PERSIAN_KEYBOARD[char];
    }
    const mapped = ENGLISH_TO_PERSIAN_KEYBOARD[char.toLowerCase()];
    return mapped ?? char;
  });

export const normalizePersianLookalikes = (input: string): string =>
  input.replace(/آ/g, "ا").replace(/ژ/g, "ز");

export const normalizeDropdownSearch = (input: string): string =>
  normalizePersianDigits(input).toLowerCase();

export const matchesDropdownSearch = (
  label: string,
  searchValue: string,
): boolean => {
  if (!searchValue) return true;

  const normalizedLabel = label.toLowerCase();
  const normalizedSearch = normalizeDropdownSearch(searchValue);
  const persianSearch = englishKeyboardToPersian(
    normalizePersianDigits(searchValue),
  );

  return (
    normalizePersianLookalikes(normalizedLabel).includes(
      normalizePersianLookalikes(normalizedSearch),
    ) || normalizedLabel.includes(persianSearch)
  );
};
